import Button from "@mui/material/Button";
import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {FlexFiller} from "../atoms/FlexFiller/FlexFiller";
import { styled } from '@mui/material/styles';
import {filterQuestions} from "../helpers/constants/filterQuestions";

/*const CustomerContainer = styled('div')({
  display: 'flex',
  border: '1px solid #eee',
  alignItems: 'center',
  padding: 10,
  fontSize: 14,
  cursor: 'pointer',
  borderWidth: '1px 1px 0 1px',
  '&:last-child': {
    borderWidth: '1px 1px 1px 1px'
  }
});*/

const Marker = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.primaryColour}`,
  borderRadius: 3,
  display: 'inline-block',
  textTransform: 'uppercase',
  color: theme.primaryColour,
  background: '#fff',
  fontSize: 10,
  padding: 2,
}));

const ProfileValue = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.primary.main
}));

/*const StyledAvatar = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));*/

const CustomerDetailsHeader = ({customer}) => {
  return (
    <div style={{display:'flex', alignItems: 'center'}}>
      <div>
        <div style={{fontSize:28, marginBottom:5}}>{customer.firstName} {customer.lastName}</div>
        <div style={{fontSize:12, marginBottom:5, fontWeight:'bold'}}>
          {customer.email}{customer.phone && <span>, {customer.phone}</span>}
        </div>
        <CustomerDates customer={customer} />
      </div>
      <FlexFiller/>
      <CustomerDetailsGroup customer={customer} />
    </div>
  );
}

const CustomerDetailsGroup = ({customer}) => {
  const spanStyle = {fontSize:16, fontWeight:'bold'};
  return (
    <div style={{textAlign: 'right', fontSize:13, display:'flex', gap:5, flexDirection:'column'}}>
      <div style={{fontSize:14}}>Group <span style={{fontWeight: 'bold'}}>{customer.group || 'None'}</span></div>
      <div>Room <span style={spanStyle}>{customer.space || 'Day Guest'}</span></div>
      {customer.present && <div><Marker label={'Checked In'} /></div>}
    </div>
  );
}

const TAG_GROUP_BY_KEY = {
  roomTags: 'room',
  musicTags: 'music',
  foodTags: 'food',
  beverageTags: 'beverage',
  logisticsTags: 'logistics',
  marketingTags: 'marketing',
  quizTags: 'quiz',
  feedbackTags: 'feedback',
  activitiesTags: 'activities',
  miscTags: 'misc',
};

const normalizeTagValue = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join(', ');
  }

  if (value === null || value === undefined) {
    return '';
  }

  return String(value);
};

const isFilteredQuestion = (label = '') => {
  const normalised = String(label).trim().toLowerCase();
  return filterQuestions.some(
    (question) => String(question).trim().toLowerCase() === normalised
  );
};

const getPropertyTagValues = ({customer, tag}) => {
  const properties = customer?.properties;
  const groupPrefix = TAG_GROUP_BY_KEY[tag];

  if (!properties || !groupPrefix || typeof properties !== 'object') {
    return [];
  }

  return Object.entries(properties)
    .filter(([key]) => key.startsWith(`${groupPrefix}--`))
    .map(([, value]) => {
      if (!value || typeof value !== 'object') {
        return null;
      }

      const label = value.label || '';
      if (!label || isFilteredQuestion(label)) {
        return null;
      }

      return {
        label,
        value: normalizeTagValue(value.value),
      };
    })
    .filter(Boolean);
};

const getLegacyTagValues = ({customer, tag}) => {
  if (!Array.isArray(customer?.[tag])) {
    return [];
  }

  return customer[tag]
    .map((tagValue) => {
      let label;
      let values;

      if (!tagValue?.label) {
        const keyVal = String(tagValue).split(': ');
        label = keyVal[0] || '';
        values = keyVal.slice(1).join(': ');
      } else {
        label = tagValue.label;
        values = tagValue.value;
      }

      if (!label || isFilteredQuestion(label)) {
        return null;
      }

      return {
        label,
        value: normalizeTagValue(values),
      };
    })
    .filter(Boolean);
};

const DisplayTag = ({customer, heading='Test', tag = 'test', string= false}) => {
  const propertyTagValues = getPropertyTagValues({customer, tag});
  const customerArray = propertyTagValues.length
    ? propertyTagValues
    : getLegacyTagValues({customer, tag});

  if (customerArray.length) {
    return (
      <React.Fragment>
        {!!customerArray.length &&
          <Notes heading={heading}>
            {!string && customerArray.map((keyValue, index) => (
              <React.Fragment key={index}>
                {!!keyValue.value && <div style={{
                  border: '1px solid rgba(0, 0, 0, 0.23)',
                  fontSize: 13,
                  textTransform: 'capitalize',
                  borderRadius: 26,
                  padding:'8px',
                  display:'flex',
                  gap:5,
                  alignItems: 'center'
                }}>
                  <div>{keyValue.label.replace(/;/g, ', ')}</div>
                  <ProfileValue>{String(keyValue.value).replace(/;/g, ', ')}</ProfileValue>
                </div>}
              </React.Fragment>
              ))
            }
          </Notes>}
      </React.Fragment>
    );
  } else {
    return null;
  }
}

const Notes = ({heading='Test', children}) => {
  return (
    <div style={{borderTop:'1px solid #ccc', padding:'16px 0', marginBottom:6}}>
      <h2 className={'box-head'}>{heading}</h2>
      <div style={{display:'flex', gap:5, flexWrap: 'wrap'}}>{children}</div>
    </div>
  );
}

const processTagHeading = label => label.replace('rh_', '').replace('_',' ');

const DisplayRH = ({customer}) => {
  return (
    <React.Fragment>
      {Object.keys(customer).map(key => (
        <React.Fragment key={key}>
          {(key.indexOf('rh_') !== -1 && customer[key]) ?
            <DisplayTag customer={customer} heading={processTagHeading(key)} tag={key} string={true}/> : null}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

export const CustomerDates = ({customer}) => {
  let dateStyle = {
    fontWeight: 'bold'
  };

  return (
    <div style={{fontSize:12, marginBottom:6}}>Arrival <span style={dateStyle}>{customer.arrival}</span>, Departure <span style={dateStyle}>{customer.leave}</span>
    </div>
  );
}

export const MarkerComponent = ({label}) => {
  return (<Marker>{label}</Marker>)
}

export const CustomerDetails = ({customer, open, onClose, formSubmission = false}) => {
  return (
    <Dialog
      open={open}
      fullWidth={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <div style={{marginBottom:16}}>
          {!formSubmission && <CustomerDetailsHeader customer={customer} />}
          {formSubmission && <h3>Form Submission</h3>}
        </div>
        {customer.mewsNotes  && <Notes heading={'Mews Notes'}>
          <div style={{fontSize:14}}>{customer.mewsNotes}</div>
        </Notes>}
        <DisplayTag tag={'roomTags'} heading={'Bedroom'} customer={customer} />
        <DisplayTag tag={'musicTags'} heading={'Music'} customer={customer} />
        <DisplayTag tag={'foodTags'} heading={'Food'} customer={customer} />
        <DisplayTag tag={'beverageTags'} heading={'Beverages'} customer={customer} />
        <DisplayTag tag={'logisticsTags'} heading={'Logistics'} customer={customer} />
        <DisplayTag tag={'marketingTags'} heading={'Marketing'} customer={customer} />
        <DisplayTag tag={'quizTags'} heading={'Quiz'} customer={customer} />
        <DisplayTag tag={'feedbackTags'} heading={'Feedback'} customer={customer} />
        <DisplayTag tag={'activitiesTags'} heading={'Activities'} customer={customer} />
        <DisplayTag tag={'miscTags'} heading={'Misc'} customer={customer} />
        <DisplayRH customer={customer} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
